import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Dayreport } from 'src/app/classes/dayreport.class';
import { ApiResponse, ApiService } from './api/api.service';

@Injectable({ providedIn: 'root' })
export class DayreportService {
    constructor(private apiService: ApiService) {}

    public save(dayreport: Dayreport): Observable<ApiResponse<Dayreport>> {
        return this.apiService.postCall$<Dayreport>('dayreports', dayreport);
    }

    public deleteArticle(articleId: number): Observable<ApiResponse<string>> {
        return this.apiService.deleteCall$<string>(`dayreports/articles/${articleId}`);
    }

    public getByPlanningId(planningId: number): Observable<ApiResponse<Dayreport>> {
        return this.apiService.getCall$<Dayreport>(`dayreports/planning/${planningId}`);
    }

    public getPdf(planningId: number): Observable<Blob> {
        return this.apiService.getBlobCall(`dayreports/pdf/${planningId}`);
    }
}
